import { render, staticRenderFns } from "./SelectReactsAside.vue?vue&type=template&id=44322a7e&scoped=true&"
import script from "./SelectReactsAside.vue?vue&type=script&lang=js&"
export * from "./SelectReactsAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44322a7e",
  null
  
)

export default component.exports